<div class="row">
  <div class="col-12 col-md-6">
    <input #textbox class="selectmore-text form-control" placeholder="{{'APPLICATION.TRAVEL_HISTORY.START_TYPING' | translate }}" type="text" (keyup)="filter($event)">
    <ul class="select-list">
      @for (item of collection; track item) {
        <div>
          @if (alphaSort && isNewGroup(item)) {
            <li class="list-group-header">
              {{ getSortLetter() }}
            </li>
          }
          @if (!isSelected(item)) {
            <li>
              @if (multiSelect) {
                <button type="button" (click)="add(item)">
                  {{ item.description }}
                  <i class="fa fa-plus"></i>
                </button>
              }
            </li>
          }
          @if (isSelected(item)) {
            <li class="selected">
              {{ item.description }}
              <i class="fa fa-check"></i>
            </li>
          }
        </div>
      }
    </ul>
  </div>

  @if (multiSelect && selectedItems.length > 0) {
    <div class="col-12 col-md-6">
      <br class="d-md-none"/>
      <h4 class="select-list-added-title" translate>APPLICATION.TRAVEL_HISTORY.COUNTRIES_ADDED</h4>
      <hr>
        <ul class="select-list-added">
          @for (item of selectedItems; track item) {
            <div>
              <li>
                {{ item.description }}
                @if (multiSelect) {
                  <button type="button" (click)="remove(item)" title="{{'GENERAL_REUSABLE.DELETE' | translate}}">
                    <i class="far fa-trash-alt"></i>
                  </button>
                }
              </li>
            </div>
          }
        </ul>
      </div>
    }
  </div>